import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellersRoutingModule } from './sellers-routing.module';
import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';

import { SellersComponent } from './sellers/sellers.component';
import { SellersHeaderComponent } from './sellers-header/sellers-header.component';
import { SellersSummaryComponent } from './sellers-summary/sellers-summary.component';
import { SellersDataComponent } from './sellers-data/sellers-data.component';
import { SellersDataEmptyComponent } from './sellers-data-empty/sellers-data-empty.component';
import { SellersDataTableComponent } from './sellers-data-table/sellers-data-table.component';
import { SellersStoresDialogComponent } from './sellers-stores-dialog/sellers-stores-dialog.component';
import { SellersSetPhoneDialogComponent } from './sellers-set-phone-dialog/sellers-set-phone-dialog.component';
import { SellersEditDialogComponent } from './sellers-edit-dialog/sellers-edit-dialog.component';
import { SellersFilterDialogComponent } from './sellers-filter-dialog/sellers-filter-dialog.component';
import { SellersFiltersComponent } from './sellers-filters/sellers-filters.component';
import { SellersSetMfaDialogComponent } from './sellers-set-mfa-dialog/sellers-set-mfa-dialog.component';
import { SellersAccessControlDialogComponent } from './sellers-access-control-dialog/sellers-access-control-dialog.component';
import { SellersConfirmOtpDialogComponent } from './sellers-confirm-otp-dialog/sellers-confirm-otp-dialog.component';

@NgModule({
  declarations: [
    SellersComponent,
    SellersHeaderComponent,
    SellersSummaryComponent,
    SellersDataComponent,
    SellersDataEmptyComponent,
    SellersDataTableComponent,
    SellersStoresDialogComponent,
    SellersSetPhoneDialogComponent,
    SellersEditDialogComponent,
    SellersFilterDialogComponent,
    SellersFiltersComponent,
    SellersSetMfaDialogComponent,
    SellersAccessControlDialogComponent,
    SellersConfirmOtpDialogComponent,
  ],
  imports: [
    CommonModule,
    SellersRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatMenuModule,
  ],
})
export class SellersModule {}
